<template>

  <div>
    <b-card no-body>
      <b-card-body fluid="xl">
        <b-form @submit.stop.prevent="onSubmit">
          <b-row>
            <b-col cols="12">
              <b-form-group label="Price" label-for="price">
                <b-form-input id="price"
                              name="price"
                              :state="validateState('price')"
                              aria-describedby="liveFeedbackPrice"
                              type = number
                              v-model.trim="$v.form.price.$model"
                              autofocus />
              </b-form-group>
              <b-form-invalid-feedback id="liveFeedbackPrice">Please only enter number.</b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Quantity" label-for="qty">
                <b-form-input id="qty"
                              :state="validateState('qty')"
                              aria-describedby="liveFeedbackQty"
                              name="qty"
                              type=number
                              v-model.number="$v.form.qty.$model" />
              </b-form-group>
              <b-form-invalid-feedback id="liveFeedbackQty">Please only enter number.</b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6" class="mw3">
              <b-button @click="savePriceQty" :disabled="$v.form.$invalid">Submit</b-button>
            </b-col>
            <b-col cols="6" class="mw3">
              <b-button @click="onCancel">Cancel</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
  </div>

</template>

<script>

  import Vue from 'vue';
  import { numeric, decimal, required, minValue } from 'vuelidate/lib/validators';
  import { validationMixin } from "vuelidate";

  const productShape = {
    price: 0,
    qty: 1
  }
  export default {
    mixins: [validationMixin],
    name: 'VariablePrdPriceModal',
    props: {
      product: Object
    },
    data: function() {
      return {
        form: Object.assign({}, productShape)
      }
    },
    validations: {
      form: {
        price: {
          decimal,
          required
        },
        qty: {
          numeric,
          required,
          minValue: minValue(1)
        }
      }
    },
    computed: {
      isValid() {
        this.$v.$touch()
        return !this.$v.form.$anyError
      },
      isDirty() {
        return this.$v.form.$anyDirty
      }
    },
    methods: {
      onCancel() {
        this.form = Object.assign({}, productShape)
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.$emit('cancel')
      },
      savePriceQty() {

        if (this.isValid) {
          var newProduct = JSON.parse(JSON.stringify(this.product))
          newProduct.price = this.form.price;
          newProduct.qty = this.form.qty;
          newProduct.actualPrice = this.form.price;
          this.$emit('success', newProduct)
        }
      },
      validateState(name) {
        const { $dirty, $error } = this.$v.form[name]
        return $dirty ? !$error : null
      }
    },
    created() {

      if (this.product !== null) {
        this.form.price = this.product.actualPrice;
        this.form.qty = this.product.qty
      }
    }
  }

</script>

<style>

</style>
